const ApiUrl = `${process.env.VUE_APP_API_PP_PARTIDOS}`
import axios from '@/interceptor-core'

export const requestRenunciaPPMixin = {
  methods: {
    getRenunciaVer(id) {
      const body = {
        id: id
      }
      return axios.post(`${ApiUrl}/partidos/renuncia/ver`, body);
    },
    getListaRenuncia(body) {
      return axios.post(`${ApiUrl}/renuncia/lista`, body)
    },
  }
};
